import React from 'react';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import {
  CheckoutFormProps,
  DefaultFormActions,
  Form,
  useEnhancedForm,
} from '../../apiForm/form';
import { SelectOptionsField, TextField } from '../../apiForm/form/input';
import ArrayWrapper from '../../apiForm/wrapper/ArrayWrapper';
import CheckboxField from '../../apiForm/form/input/CheckboxField';
import ExpandableFieldset from '../../apiForm/form/ExpandableFieldset';

export default function FulfillmentConfigForm({
  defaultValues = {},
  errors = {},
  onSubmit,
  readonly,
}: CheckoutFormProps<any>) {
  const { t } = useTranslation();
  const { handleSubmit, control, formState, getValues, reset } =
    useEnhancedForm({ defaultValues, errors });
  const serviceCredentials = getValues('serviceCredentials') || [];
  const serviceCredentialsHelperText =
    serviceCredentials.length === 0
      ? t('checkoutConfig.helperText.general.noServiceCredentials')
      : t('checkoutConfig.helperText.fulfillmentConfigs.serviceCredentialID');

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <ExpandableFieldset
        legend={t('checkoutConfig.legend.fulfillmentConfigs')}
      >
        <ArrayWrapper
          control={control}
          name="fulfillmentConfigs"
          defaultValue={{}}
          addLabel={t('checkoutConfig.arrayWrapper.fulfillmentConfig.add')}
          removeLabel={t(
            'checkoutConfig.arrayWrapper.fulfillmentConfig.remove',
          )}
          render={(index: number) => (
            <Stack spacing={1}>
              <TextField
                control={control}
                name={`fulfillmentConfigs.[${index}].fulfillmentType`}
                disabled={readonly}
                label={t(
                  'checkoutConfig.label.fulfillmentConfigs.fulfillmentType',
                )}
              />
              <TextField
                control={control}
                name={`fulfillmentConfigs.[${index}].createURL`}
                disabled={readonly}
                label={t('checkoutConfig.label.fulfillmentConfigs.createURL')}
              />
              <TextField
                control={control}
                name={`fulfillmentConfigs.[${index}].token`}
                disabled={readonly}
                label={t('checkoutConfig.label.fulfillmentConfigs.token')}
              />
              <SelectOptionsField
                control={control}
                name={`fulfillmentConfigs.[${index}].serviceCredentialID`}
                disabled={readonly || serviceCredentials.length === 0}
                options={serviceCredentials}
                valueFrom="id"
                labelFrom="id"
                optional
                label={t(
                  'checkoutConfig.label.fulfillmentConfigs.serviceCredentialID',
                )}
                helperText={serviceCredentialsHelperText}
              />
              <TextField
                control={control}
                name={`fulfillmentConfigs.[${index}].shops`}
                disabled={readonly}
                optional
                label={`${t('checkoutConfig.label.fulfillmentConfigs.shops')} (comma separated)`}
              />
              <CheckboxField
                control={control}
                name={`fulfillmentConfigs.[${index}].addPaymentReference`}
                disabled={readonly}
                label={t(
                  'checkoutConfig.label.fulfillmentConfigs.addPaymentReference',
                )}
              />
              <CheckboxField
                control={control}
                name={`fulfillmentConfigs.[${index}].splitByLineItem`}
                disabled={readonly}
                label={t(
                  'checkoutConfig.label.fulfillmentConfigs.splitByLineItem',
                )}
              />
            </Stack>
          )}
        />
      </ExpandableFieldset>

      <DefaultFormActions
        formState={formState}
        cancelNavigationTarget="/"
        noCancelNavigation
        reset={reset}
        getValues={getValues}
      />
    </Form>
  );
}
